export default class SearchFilters {
  init($) {
    // Elements
    const $filtersWrap = $('#online_consult-filters');
    const $hero = $('#online_consult-hero');
    const $body = $('body');

    if (!$filtersWrap.length) {
      return;
    }

    // Filters visibility on mobile
    $filtersWrap.find('button').click(() => $filtersWrap.toggleClass('active'));

    // Fixing filters
    ($body.hasClass('v2-body') || $body.hasClass('mm-wrapper') ? $body : $(window)).scroll(() => {
      if ($(window).scrollTop() < $hero.offset().top + $hero.height()) {
        $filtersWrap.removeClass('fixed');
      } else {
        $filtersWrap.addClass('fixed');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./_common/scripts/search-filters.js